<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    width="700px"
    :colon="true"
    label-width="90px"
    data-automation="addUser"
  >
    <ux-form-item :label="$t('HT.addUser.user')" prop="username">
      <ux-input
        v-model.trim()="formData.username"
        :maxlength="30"
        :placeholder="$t('HT.changePhone.placeholder1')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addUser.nickname')" prop="nickname">
      <ux-input
        v-model.trim()="formData.nickname"
        :maxlength="20"
        :placeholder="$t('HT.changePhone.placeholder2')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addUser.phone')" prop="phone">
      <ux-input
        v-model.trim()="formData.phone"
        :maxlength="11"
        :placeholder="$t('HT.changePhone.placeholder3')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addUser.email')" prop="email">
      <ux-input v-model.trim()="formData.email" :placeholder="$t('HT.rules.bindemail.email')"></ux-input>
    </ux-form-item>
    <ux-form-item
      v-if="showOwner"
      :label="$t('HT.addUser.parentAccount')"
      required
      prop="parent_id"
    >
      <ux-select
        v-model="formData.parent_id"
        label="label"
        value="value"
        clearable
        :options="ownerOptions"
        :placeholder="$t('HT.addUser.parentAccount.placeholder')"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.router.userListGroup')" prop="group_ids">
      <ux-select
        v-if="userData.supervisor && showOption"
        v-model="formData.group_ids"
        label="label"
        value="value"
        clearable
        :options="userOption"
      ></ux-select>
      <div v-else>
        <span v-for="item in noSuperUserOption">{{ item.label }}</span>
      </div>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addUser.psw')" prop="password">
      <ux-input
        v-model.trim()="formData.password"
        type="password"
        :maxlength="18"
        show-password
        :placeholder="$t('HT.changePhone.placeholder5')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.passwdCheck')" prop="passwdCheck">
      <ux-input
        v-model.trim()="formData.passwdCheck"
        type="password"
        :maxlength="18"
        show-password
        :placeholder="$t('HT.changePhone.placeholder5')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>
<script>
import store from '../../../store/index';
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showOption: {
      type: Boolean,
      default: true
    },
    // 是否展示三级用户所属的二级账号
    showOwner: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {
          nickname: '', //姓名
          username: '', // 用户名
          phone: '', // 手机号
          // type: '', // 账号类型
          email: '', //邮箱
          parent_id: '', // 三级用户所属的二级账号 ID
          group_ids: '', //用户组
          password: '', // 密码
          passwdCheck: '' // 确认密码
        };
      }
    }
  },
  data() {
    return {
      userData: {}, // 用户信息
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.register(this),
      // bindValue: 's-1',
      userOption: [],
      // 可作为三级用户上级的二级账号
      ownerOptions: [],
      noSuperUserOption: this.list // 非超管主账号的用户组信息
    };
  },
  created() {
    this.getGroup();
    if (this.showOwner) {
      this.getOwners();
    }
  },
  mounted() {
    this.userData = store.state.login.userData;
    if (!(this.userData.supervisor && this.showOption)) {
      // 不是超级管理员
      this.formData.group_ids = this.noSuperUserOption[0].value;
    }
  },
  methods: {
    /**
     * 获取三级用户可选择的所属二级账号
     */
    getOwners() {
      this.$api.user.getOwners().then((res) => {
        if (res.code == 10000) {
          this.ownerOptions = (res.data || []).map((item) => ({
            label: item.username,
            value: item.id
          }));
        }
      });
    },
    /**
     * 获取用户组
     */
    getGroup() {
      this.$api.system.getGroup().then((res) => {
        if (res.code == 10000) {
          // 转换成用户组单选框所需要的格式
          let result = res.data.map((item) => {
            return {
              label: item.group_name,
              value: item.id
            };
          });
          this.userOption = result;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-user {
  width: 400px;
}
</style>
